// Boneyard site shell: menu drawer, barber bio "Read more", click-to-play video. No dependencies.
const dd = document.getElementById('bys-dd');
const ddBtn = document.querySelector('[data-bys-dd-toggle]');
if (dd && ddBtn) {
  const setOpen = (open) => {
    dd.hidden = !open;
    ddBtn.setAttribute('aria-expanded', String(open));
    document.documentElement.classList.toggle('bys-dd-open', open);
  };
  ddBtn.addEventListener('click', () => setOpen(dd.hidden));
  document.addEventListener('click', (e) => {
    if (!dd.hidden && !dd.contains(e.target) && !ddBtn.contains(e.target)) setOpen(false);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !dd.hidden) { setOpen(false); ddBtn.focus(); }
  });
  dd.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => setOpen(false)));
}

// Barber bios: show "Read more" only when the bio is actually cut off.
const fitBios = () =>
  document.querySelectorAll('.bys-bio.is-clamped:not(.is-open)').forEach((bio) => {
    const btn = bio.nextElementSibling;
    if (btn?.classList.contains('bys-more')) btn.hidden = bio.scrollHeight <= bio.clientHeight + 2;
  });
fitBios();
window.addEventListener('load', fitBios);
window.addEventListener('resize', fitBios);

document.addEventListener('click', (e) => {
  const more = e.target.closest?.('.bys-more');
  if (more) {
    const bio = more.previousElementSibling;
    const open = bio.classList.toggle('is-open');
    more.textContent = open ? 'Show less' : 'Read more';
    more.setAttribute('aria-expanded', String(open));
    return;
  }
  const v = e.target.closest?.('.bys-video[data-bys-yt]');
  if (v && !v.querySelector('iframe')) {
    const f = document.createElement('iframe');
    f.src = `https://www.youtube-nocookie.com/embed/${v.dataset.bysYt}?autoplay=1&rel=0&playsinline=1`;
    f.title = v.dataset.title || 'YouTube video';
    f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    f.referrerPolicy = 'strict-origin-when-cross-origin';
    f.allowFullscreen = true;
    v.append(f);
  }
});

// Google Maps embeds: set the iframe src only once the map is near the screen, and never before the page has loaded.
// Moves ~500 KB of Maps scripts after page load so they don't compete with it (location pages have a map in the hero).
const maps = [...document.querySelectorAll('iframe[data-bys-src]')];
if (maps.length) {
  const show = (f) => { if (!f.src) f.src = f.dataset.bysSrc; };
  const start = () => {
    if (!('IntersectionObserver' in window)) { maps.forEach(show); return; }
    const io = new IntersectionObserver((entries) => entries.forEach((e) => { if (e.isIntersecting) { show(e.target); io.unobserve(e.target); } }), { rootMargin: '300px 0px' });
    maps.forEach((f) => io.observe(f));
  };
  if (document.readyState === 'complete') setTimeout(start, 1200); else window.addEventListener('load', () => setTimeout(start, 1200), { once: true });
}
